export default "/assets/publish-success-icon-4e5507d7642333d7f947c0a13a7e732920b8193562d1a3031855f13d2fb7bb12.svg";